import { Component, Input, OnInit } from '@angular/core';
import { PileRow } from 'src/app/services/report.service';
import {essences} from './../../services/appmeta';
@Component({
  selector: 'app-table-cell',
  templateUrl: './table-cell.component.html',
  styleUrls: ['./table-cell.component.scss'],
})
export class TableCellComponent implements OnInit {
  @Input() value:string;
  @Input() editable:boolean;
  @Input() item:PileRow;
  @Input() prop:string;
  constructor() {

  }
  turnOnEditMode(){

  }

  ngOnInit() {}

}
